'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var analytics = require('analytics');
var useAnalytics = require('use-analytics');
var StorageUtils = require('@analytics/storage-utils');
var originalSourcePlugin = require('@analytics/original-source-plugin');
var index = require('../CustomPlugins/PicoPlugin/index.js');
var resolveProviderPlugins = require('../CustomPlugins/resolveProviderPlugins.js');
var index$1 = require('../CustomPlugins/DispatchPlugin/index.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var StorageUtils__default = /*#__PURE__*/_interopDefault(StorageUtils);

var _excluded = ["plugins"],
  _excluded2 = ["children", "config", "instance"];
var getItem = StorageUtils__default["default"].getItem,
  removeItem = StorageUtils__default["default"].removeItem,
  setItem = StorageUtils__default["default"].setItem;
var defaultPlugins = [originalSourcePlugin.originalSourcePlugin()];
var analyticsConfig = {
  app: 'pico-analytics',
  debug: process.env.NODE_ENV === 'development' || process.env.STAGE === 'development'
};
if (StorageUtils.hasLocalStorage()) {
  analyticsConfig.storage = {
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem
  };
}
var PicoAnalytics = function PicoAnalytics(config) {
  var _analyticsConfig$plug;
  var _config$plugins = config.plugins,
    plugins = _config$plugins === void 0 ? {} : _config$plugins,
    pico_plugin_options = _rollupPluginBabelHelpers.objectWithoutPropertiesLoose(config, _excluded);
  analyticsConfig.plugins = [].concat(defaultPlugins, [index(pico_plugin_options)]);
  !!(plugins !== null && plugins !== void 0 && plugins.dispatch) && analyticsConfig.plugins.push(index$1());
  (_analyticsConfig$plug = analyticsConfig.plugins).push.apply(_analyticsConfig$plug, resolveProviderPlugins(plugins, pico_plugin_options));
  return analytics.Analytics(analyticsConfig);
};
var PicoAnalyticsProvider = function PicoAnalyticsProvider(_ref) {
  var children = _ref.children,
    config = _ref.config,
    _ref$instance = _ref.instance,
    instance = _ref$instance === void 0 ? null : _ref$instance,
    props = _rollupPluginBabelHelpers.objectWithoutPropertiesLoose(_ref, _excluded2);
  return /*#__PURE__*/React__default["default"].createElement(useAnalytics.AnalyticsProvider, {
    instance: instance || PicoAnalytics(config)
  }, /*#__PURE__*/React__default["default"].cloneElement(children, props));
};

exports.PicoAnalytics = PicoAnalytics;
exports.PicoAnalyticsProvider = PicoAnalyticsProvider;
//# sourceMappingURL=index.js.map
